// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible';
import request from './utile/request'
import request1 from './utile/request1'
import request2 from './utile/request2'
import request5 from './utile/request5'
import request6 from './utile/request6'
import baseSpma from './utile/baseSpma'
import baseGift from "./utile/baseGift";
import requestOther from './utile/requestOther.js'
import docCookies from '@/assets/js/utile.js'
import Fingerprint2 from 'fingerprintjs2'
import store from '@/store/index';
import VueClipboard from 'vue-clipboard2';//复制到剪切板的功能


Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(VueClipboard)
Vue.prototype.$request = request
Vue.prototype.$request1 = request1
Vue.prototype.$request2 = request2
Vue.prototype.$request5 = request5
Vue.prototype.$request6 = request6
Vue.prototype.$baseSpma = baseSpma
Vue.prototype.$baseGift = baseGift
Vue.prototype.$requestOther = requestOther;
Vue.prototype.$docCookies = docCookies;
Vue.prototype.$fingerprint2 = Fingerprint2;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];


export const eventBus = new Vue();//用于组件之间的数据传输

/* eslint-disable no-new */
window.eventBus = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js